import {Box} from "@chakra-ui/react";
import Footer from '../../layouts/Footer';
import Header from '../../layouts/Header';
import ItemDetailBody from '../../components/ItemDetailBody';

const ItemDetail = (props) => {

	return(
		<Box>
      <Header />
			<ItemDetailBody params={props.id}/>
      <Footer />
		</Box>
	)
}

export default ItemDetail;